import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import { object, shape, string, number, bool, func } from 'prop-types';
import { Link } from 'react-router-dom';
import { stringify } from 'query-string';
import cn from 'classnames';
import OfferTopLinkItem from './OfferTopLinkItem';

const getItem = (array = [], id) => array.find(el => el.id === id);

const getParams = ({ offer, landing, prelanding }) => {
  const params = {
    offer: offer.id,
  };
  if (landing !== undefined) {
    params['landing'] = landing;
  }
  if (prelanding !== undefined) {
    params['prelanding'] = prelanding;
  }
  return stringify(params);
};

const propTypes = {
  item: shape({
    source: string,
    landing: number,
    prelanding: number,
  }),
  offer: object,
  disabled: bool,
  onClick: func,
  inOfferPage: bool,
};

const defaiultProps = {
  item: {},
  offer: {},
  onClick() {},
  inOfferPage: false,
};

const OfferTopLink = ({
  item: { landing, prelanding, source },
  offer,
  disabled,
  onClick,
  inOfferPage,
  theme,
}) => {
  const topprelanding = getItem(offer.transits, prelanding);
  const topLanding = getItem(offer.landings, landing);

  const containerClasses = cn('offer-top-link', { card: inOfferPage });
  const titleClasses = cn('offer-top-link-title', { 'card-header': inOfferPage });
  const bodyClasses = cn('offer-top-link-wrapper', { 'card-body': inOfferPage });
  const footerClasses = cn('offer-top-link-controls', { 'card-footer': inOfferPage });
  const renderButton = () => {
    if (inOfferPage) {
      if (offer.modifies.is_my) {
        return (
          <Link
            className="btn btn-primary btn-sm"
            to={{
              pathname: '/tools/flows/create',
              search: `?${getParams({ offer, landing, prelanding })}`,
            }}
          >
            <FormattedMessage
              id="offer.top-link.use"
              defaultMessage="Use this angle"
            />
          </Link>
        )
      } else {
        return (
          <Button
            onClick={() => {
              onClick(offer.id)
            }}
            size="sm"
            type="button"
            color="primary"
          >
            <FormattedMessage id="offer.top-link.connect-offer" defaultMessage="Activate offer" />
          </Button>
        );
      }
    }

    return (
      <Button onClick={onClick} size="sm" color="primary" disabled={disabled}>
        <FormattedMessage id="offer.top-link.use" defaultMessage="Use this angle" />
      </Button>
    );
  };

  return (
    <div className={containerClasses}>
      <p className={titleClasses}>
        <FormattedMessage id="offer.top-link.title" defaultMessage="offer.top-link.title" />
      </p>
      <ul className={bodyClasses}>
        {source && (
          <OfferTopLinkItem
            icon="hand"
            title={<FormattedMessage id="offer.top-link.source" defaultMessage="Source" />}
            name={source}
          />
        )}
        {topprelanding && (
          <OfferTopLinkItem
            icon="file-fill"
            title={
              <FormattedMessage id="offer.top-link.prelanding" defaultMessage="prelanding page" />
            }
            name={topprelanding.title}
            link={topprelanding.url}
          />
        )}
        {topLanding && (
          <OfferTopLinkItem
            icon="star"
            title={<FormattedMessage id="offer.top-link.landing" defaultMessage="Landing page" />}
            name={topLanding.title}
            link={topLanding.url}
          />
        )}
      </ul>
      <div className={footerClasses}>{renderButton()}</div>
    </div>
  );
};

OfferTopLink.propTypes = propTypes;
OfferTopLink.defaiultProps = defaiultProps;

export default OfferTopLink;
